(function () {
  if (window.agroProgrammedPurchaseCardsInitialized) {
    return;
  }

  window.agroProgrammedPurchaseCardsInitialized = true;

  function normalizeValue(value) {
    return (value || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function parseVariants(card) {
    const productId = card.dataset.productId;
    const dataEl = productId ? document.getElementById(`variant-data-${productId}`) : null;

    if (!dataEl) {
      return [];
    }

    try {
      return JSON.parse(dataEl.textContent);
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  function findVariantByOptions(variants, selectedOptions) {
    return variants.find(function (variant) {
      if (selectedOptions['1'] && variant.option1 !== selectedOptions['1']) return false;
      if (selectedOptions['2'] && variant.option2 !== selectedOptions['2']) return false;
      if (selectedOptions['3'] && variant.option3 !== selectedOptions['3']) return false;
      return true;
    });
  }

  function getCurrentAvulsaVariant(card, variants) {
    const optionInputs = card.querySelectorAll('input.variant-option[data-option-position]');

    if (optionInputs.length) {
      const selectedOptions = {};

      optionInputs.forEach(function (input) {
        if (input.checked) {
          selectedOptions[input.dataset.optionPosition] = input.value;
        }
      });

      if (card.dataset.purchaseOptionPosition) {
        selectedOptions[card.dataset.purchaseOptionPosition] = card.dataset.purchaseOptionValue || 'Avulsa';
      }

      return findVariantByOptions(variants, selectedOptions);
    }

    const checkedVariantInput = card.querySelector('input[type="radio"][name="id"]:checked');
    if (checkedVariantInput) {
      const checkedId = parseInt(checkedVariantInput.value, 10);
      return variants.find(function (variant) {
        return variant.id === checkedId;
      });
    }

    const purchaseOptionPosition = parseInt(card.dataset.purchaseOptionPosition || '0', 10);
    const purchaseOptionKey = purchaseOptionPosition ? `option${purchaseOptionPosition}` : null;

    return variants.find(function (variant) {
      if (!purchaseOptionKey) return variant.available;
      return normalizeValue(variant[purchaseOptionKey]) === normalizeValue(card.dataset.purchaseOptionValue || 'Avulsa');
    });
  }

  function getRecurringVariants(card, variants, avulsaVariant) {
    const purchaseOptionPosition = parseInt(card.dataset.purchaseOptionPosition || '0', 10);
    const purchaseOptionKey = purchaseOptionPosition ? `option${purchaseOptionPosition}` : null;

    return variants.filter(function (variant) {
      if (!variant.available || !purchaseOptionKey) {
        return false;
      }

      if (normalizeValue(variant[purchaseOptionKey]) === normalizeValue(card.dataset.purchaseOptionValue || 'Avulsa')) {
        return false;
      }

      for (let position = 1; position <= 3; position += 1) {
        if (position === purchaseOptionPosition) {
          continue;
        }

        const optionKey = `option${position}`;
        if (avulsaVariant[optionKey] && variant[optionKey] !== avulsaVariant[optionKey]) {
          return false;
        }
      }

      return true;
    });
  }

  function pickRecurringVariant(recurringVariants, preferredId) {
    if (!recurringVariants.length) {
      return null;
    }

    if (preferredId) {
      const preferredById = recurringVariants.find(function (variant) {
        return String(variant.id) === String(preferredId);
      });

      if (preferredById) {
        return preferredById;
      }
    }

    const monthlyVariant = recurringVariants.find(function (variant) {
      return ['option1', 'option2', 'option3'].some(function (key) {
        return normalizeValue(variant[key]) === 'mensal';
      });
    });

    return monthlyVariant || recurringVariants[0];
  }

  function getRecurringPlanName(card, variant) {
    const purchaseOptionPosition = parseInt(card.dataset.purchaseOptionPosition || '0', 10);
    const purchaseOptionKey = purchaseOptionPosition ? `option${purchaseOptionPosition}` : null;
    return purchaseOptionKey ? variant[purchaseOptionKey] : '';
  }

  function closeDropdown(module) {
    const menu = module && module.querySelector('[data-programmed-frequency-menu]');
    const toggle = module && module.querySelector('[data-programmed-frequency-toggle]');
    const card = module && module.closest('.product-card');

    if (menu) {
      menu.classList.add('hidden');
    }

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }

    if (card) {
      card.classList.remove('programmed-dropdown-open');
    }
  }

  function syncModuleSelection(module) {
    if (!module) {
      return;
    }

    const card = module.closest('.product-card');
    const input = module.querySelector('[data-programmed-frequency-input]');
    const label = module.querySelector('[data-programmed-frequency-label]');
    const options = Array.from(module.querySelectorAll('[data-programmed-frequency-option]'));
    const selectedOption = options.find(function (option) {
      return option.dataset.variantId === input.value;
    }) || options[0];

    if (!selectedOption) {
      return;
    }

    const variants = card ? parseVariants(card) : [];
    const selectedVariant = variants.find(function (variant) {
      return String(variant.id) === String(selectedOption.dataset.variantId);
    });
    const price = module.querySelector('[data-programmed-price]');
    const compare = module.querySelector('[data-programmed-compare]');
    const compareWrap = module.querySelector('[data-programmed-compare-wrap]');
    const discount = module.querySelector('[data-programmed-discount]');
    const addButton = module.querySelector('[data-programmed-add]');
    const discountValue = parseInt(selectedOption.dataset.discount || '0', 10);
    const priceValue = selectedVariant ? selectedVariant.price_money : (selectedOption.dataset.price || '');
    const compareValue = selectedOption.dataset.compare || '';

    options.forEach(function (option) {
      const isSelected = option === selectedOption;
      option.classList.toggle('is-selected', isSelected);
      option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    input.value = selectedOption.dataset.variantId;

    if (label) {
      label.textContent = selectedOption.dataset.planName || selectedOption.textContent.trim();
    }

    if (price) {
      price.textContent = priceValue;
    }

    if (compare) {
      compare.textContent = compareValue;
    }

    if (addButton) {
      addButton.setAttribute('data-selected-variant-id', selectedOption.dataset.variantId);
    }

    if (discount && compareWrap) {
      if (discountValue > 0) {
        compareWrap.classList.remove('hidden');
        discount.classList.remove('hidden');
        discount.textContent = `-${discountValue}%`;
      } else {
        compareWrap.classList.add('hidden');
        discount.classList.add('hidden');
        discount.textContent = '';
      }
    }
  }

  function updateModule(card) {
    const module = card.querySelector('[data-programmed-purchase-card]');
    if (!module) {
      return;
    }

    const variants = parseVariants(card);
    const avulsaVariant = getCurrentAvulsaVariant(card, variants);

    if (!avulsaVariant) {
      module.classList.add('hidden');
      return;
    }

    const recurringVariants = getRecurringVariants(card, variants, avulsaVariant);
    if (!recurringVariants.length) {
      module.classList.add('hidden');
      return;
    }

    module.classList.remove('hidden');

    const menu = module.querySelector('[data-programmed-frequency-menu]');
    const input = module.querySelector('[data-programmed-frequency-input]');
    const addButton = module.querySelector('[data-programmed-add]');
    const previousVariantId = input ? input.value : (addButton ? addButton.getAttribute('data-selected-variant-id') : null);
    const selectedVariant = pickRecurringVariant(recurringVariants, previousVariantId);

    if (!selectedVariant || !menu || !input || !addButton) {
      module.classList.add('hidden');
      return;
    }

    menu.innerHTML = recurringVariants
      .map(function (variant) {
        const planName = getRecurringPlanName(card, variant);
        const discountValue = avulsaVariant.price > variant.price
          ? Math.round(((avulsaVariant.price - variant.price) * 100) / avulsaVariant.price)
          : 0;
        const selectedAttr = String(variant.id) === String(selectedVariant.id);

        return `<button type="button" class="agro-programmed-purchase-card__option${selectedAttr ? ' is-selected' : ''}" data-programmed-frequency-option data-variant-id="${variant.id}" data-plan-name="${planName.replace(/"/g, '&quot;')}" data-price="${variant.price_money.replace(/"/g, '&quot;')}" data-compare="${avulsaVariant.price_money.replace(/"/g, '&quot;')}" data-discount="${discountValue}" aria-selected="${selectedAttr ? 'true' : 'false'}" role="option">${planName}</button>`;
      })
      .join('');

    input.value = selectedVariant.id;
    syncModuleSelection(module);
    closeDropdown(module);
  }

  function handleProgrammedAdd(event) {
    const button = event.target.closest('[data-programmed-add]');
    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const module = button.closest('[data-programmed-purchase-card]');
    const card = button.closest('.product-card');
    const input = module && module.querySelector('[data-programmed-frequency-input]');
    const variantId = parseInt((input && input.value) || button.getAttribute('data-selected-variant-id') || '0', 10);

    if (!module || !card || !variantId) {
      return;
    }

    button.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        button.classList.remove('loading');

        if (response.status) {
          const alertAttributes = { message: response.description || translations.unavailable_text, type: 'error' };
          const showAlertEvent = new CustomEvent('showAlert', { detail: alertAttributes });
          window.dispatchEvent(showAlertEvent);
          return;
        }

        if (module.dataset.openDrawer === 'true' && window.ajaxCart) {
          ajaxCart.load(false, true, false, true);
        } else {
          window.location.href = routes.cart_url;
        }
      })
      .catch(function (error) {
        console.error(error);
        button.classList.remove('loading');
      });
  }

  function initProgrammedPurchaseCards() {
    document.querySelectorAll('.product-card[data-product-id]').forEach(function (card) {
      if (card.querySelector('[data-programmed-purchase-card]')) {
        updateModule(card);
      }
    });
  }

  window.agroSyncProgrammedPurchaseCard = function (element) {
    const module = element ? element.closest('[data-programmed-purchase-card]') : null;
    syncModuleSelection(module);
  };

  document.addEventListener('change', function (event) {
    const optionInput = event.target.closest('input.variant-option');
    if (!optionInput) {
      return;
    }

    const card = optionInput.closest('.product-card');
    if (card && card.querySelector('[data-programmed-purchase-card]')) {
      updateModule(card);
    }
  });

  document.addEventListener('click', function (event) {
    const option = event.target.closest('[data-programmed-frequency-option]');
    if (option) {
      event.preventDefault();
      event.stopPropagation();

      const module = option.closest('[data-programmed-purchase-card]');
      const input = module.querySelector('[data-programmed-frequency-input]');

      if (input) {
        input.value = option.dataset.variantId;
      }

      syncModuleSelection(module);
      closeDropdown(module);
      return;
    }

    const toggle = event.target.closest('[data-programmed-frequency-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const module = toggle.closest('[data-programmed-purchase-card]');
      const menu = module.querySelector('[data-programmed-frequency-menu]');
      const card = module.closest('.product-card');
      const isOpen = !menu.classList.contains('hidden');

      document.querySelectorAll('[data-programmed-purchase-card]').forEach(closeDropdown);

      if (!isOpen) {
        menu.classList.remove('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        if (card) {
          card.classList.add('programmed-dropdown-open');
        }
      }
      return;
    }

    const interactiveElement = event.target.closest('[data-programmed-purchase-card]');
    if (!interactiveElement) {
      document.querySelectorAll('[data-programmed-purchase-card]').forEach(closeDropdown);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-programmed-purchase-card]').forEach(closeDropdown);
    }
  });

  document.addEventListener('click', handleProgrammedAdd);
  document.addEventListener('DOMContentLoaded', initProgrammedPurchaseCards);
  document.addEventListener('shopify:section:load', initProgrammedPurchaseCards);
})();
